<template>
  <div>
    <div
      style="cursor:pointer;"
      @click="handleClick"
    >
      <slot name="activator" />
    </div>

    <v-form
      ref="form"
      class="mt-5"
    >
      <v-text-field
        id="dashboard-name"
        v-model="dashboard_temp.name"
        name="name"
        label="Name your dashboard"
        :counter="255"
        :rules="dashboardRules.name"
        required
        @keypress.13.prevent="create"
      />
    </v-form>
    <v-spacer />
    <div class="mt-5 text-right">
      <v-btn
        color="primary"
        text
        @click.native="handleClose"
      >
        Close
      </v-btn>
      <v-btn
        @click.native="create"
      >
        {{ dashboard? 'Apply' : 'Create' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import DashboardService from './services/DashboardService'
  export default {
    props: {
      project: {
        type: Object,
        required: true,
      },
      value: {
        type: Boolean,
        required: false,
        default: false,
      },
      dashboard: {
        type: Object,
        required: false,
      },
    },
    data () {
      return {
        dashboardRules: {
          name: [v => !!v || 'Name is required', v => (v && v.length <= 255) || 'Name must be less than 255 characters'],
        },
        dashboard_temp: {
          name: '',
        },
      }
    },
    watch: {
    },
    mounted () {
    },
    methods: {
      handleClose (e) {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.$emit('close')
      },
      handleClick (e) {
        this.dialog = true
      },
      create () {
        if (this.$refs.form.validate()) {
          DashboardService.create(this, this.project, this.dashboard_temp).then(r => {
            if (r) {
              this.$emit('create', r.data)
              this.handleClose()
            }
          })
        }
      },
    },
  }
</script>
